import { OptionTypeWithCode } from '../Select';
import { DateTypeModel, TimeUnitModel } from './DateRelativePicker.types';

export const DEFAULT_TYPE: DateTypeModel = 'IS_IN_BETWEEN';

export const TIME_UNIT_OPTIONS: OptionTypeWithCode<TimeUnitModel>[] = [
  {
    value: 'DAY',
    label: 'Day'
  },
  {
    value: 'WEEK',
    label: 'Week'
  },
  {
    value: 'MONTH',
    label: 'Month'
  },
  {
    value: 'QUARTER',
    label: 'Quarter'
  },
  {
    value: 'YEAR',
    label: 'Year'
  }
];

export const DATE_RELATIVE_OPTIONS: OptionTypeWithCode<DateTypeModel>[] = [
  {
    value: 'IS_ON',
    label: 'Is on'
  },
  {
    value: 'IS_IN_BETWEEN',
    label: 'Is in between'
  },
  {
    value: 'IS_IN_THE_NEXT',
    label: 'Is in the next'
  },
  {
    value: 'IS_IN_THE_LAST',
    label: 'Is in the last'
  },
  {
    value: 'IS_WITHIN_THIS',
    label: 'Is within this'
  },
  {
    value: 'IS_EMPTY',
    label: 'Is empty'
  }
];
